import { Component, OnInit, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { G_ModelsViewModel } from 'src/app/viewmodels/g-settings/G_ModelsViewModel';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { G_FuelTypeViewModel } from 'src/app/viewmodels/g-settings/G_FuelTypeViewModel';
import { ItemViewModel, ItemViewModel1 } from 'src/app/viewmodels/ItemViewModel';
import { FormsModule } from '@angular/forms';
import Swal from 'sweetalert2';
import { SaveVehicleModelRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';

@Component({
  selector: 'app-model-form',
  templateUrl: './model-form.component.html',
  styleUrls: ['./model-form.component.scss']
})
export class ModelFormComponent implements OnInit {
  @Input() public vm: SaveVehicleModelRequest;
  @Input() public modal_title: any;
  @Input() public bsmRef: BsModalRef;
  @Output() onSubmitted = new EventEmitter<any>();
  private submitted = false;
  public IsDublicate: boolean = false;
  public fuleTypes: ItemViewModel1[] = [];
  public brands: ItemViewModel1[] = [];
  modalRef: BsModalRef;
  selectedFuleType: any = {};
  selectedBrand: any = {};
  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
  ) {
    this.getBrands();
    this.getFuleTypes();
  }

  ngOnInit() {
    debugger
    if (this.modal_title == undefined) {
      this.modal_title = "Vechicle Model";
    }

    if (this.vm != undefined) {
      var edit = this.vm;
      this.vm = new SaveVehicleModelRequest();
      this.vm.name = edit.name;
      this.vm.id = edit.id;
      this.vm.brand = new ItemViewModel1(edit.brand.id, edit.brand.name);
      this.vm.fuelType = new ItemViewModel1(edit.fuelType.id, edit.fuelType.name);
    }
  }

  getBrands() {
    this._uow.gSettingService.GetGBrandsAsync().subscribe((res: any) => {
      this.brands = res.result;
    }, (err) => console.log(err));
  }
  getFuleTypes() {
    this._uow.gSettingService.GetFuelTypesAsync().subscribe((res: any) => {
      debugger
      this.fuleTypes = res.result;
    }, (err) => console.log(err));
  }
  openModal(template: TemplateRef<any>, lvl: number = 1) {
    if (lvl == 1) {
      this.modalRef = this._modalService.show(template);
    }
  }
  openBrandsModal(template: TemplateRef<any>) {
    this.openModal(template);
  }
  openFuleTypeModel(template: TemplateRef<any>) {
    debugger
    this.openModal(template);
  }
  brandChanged(e) {
    console.log(e);
  }
  compareFn(optionOne, optionTwo): boolean {
    debugger
    if (optionOne !== undefined && optionTwo !== undefined) {
      return optionOne.id === optionTwo.id;
    }
  }

  saveOrUpdate() {
    debugger
    this._jq.showSpinner(true);
    // this.vm.FK_G_FuelType_Id = new ItemViewModel(this.selectedFuleType.Id);
    // this.vm.Fk_G_Brand_Id = new ItemViewModel(this.selectedBrand.Id);
    this._uow.gSettingService
      .SaveVehicleModelAsync(this.vm)
      .toPromise().then((res: any) => {
        console.log(res);
        this.submitted = true;
        this.bsmRef.hide();
        this.onSubmitted.emit(this.submitted);
        Swal.fire(
          'Created!',
          'Created/Updated! Successfully',
          'success'
        )
      })
      .catch((error) => {
        Swal.fire(
          'Failure!',
          error.error.message,
          'error'
        )
        console.log(`Promise rejected with ${JSON.stringify(error)}`);
        this.onSubmitted.emit(this.submitted);
      });

  }

  onBrandChange(e) {
    console.log(e);
    // this.vm.Fk_G_Brand_Id = new ItemViewModel(e.Id, e.Name);
  }
  onFuleTypeChange(e) {
    // this.vm.FK_G_FuelType_Id = new ItemViewModel(e.Id, e.Name);
    console.log(e);
  }

  onfuleTypeSubmitted(e) {
    if (e == true) {
      this.modalRef.hide();
      this.getFuleTypes();
    }
  }
  onBrandSubmitted(e) {
    if (e == true) {
      this.modalRef.hide();
      this.getBrands();
    }
  }

  checkModelDublication(tagName) {
    debugger
    this._jq.showSpinner(true);
    this._uow.modelService.checkDublication(tagName).toPromise().then((res: any) => {
      if (res === true) {
        this.IsDublicate = false;
      } else {
        this.IsDublicate = true;
      }
      this._jq.showSpinner(false);
    }).catch((error) => {
      console.log(`Promise rejected with ${JSON.stringify(error)}`);
      this.onSubmitted.emit(this.submitted);
      this._jq.showSpinner(false);
    });
  }

  openTagTypeModel(template: TemplateRef<any>) {
    this.openModal(template);
  }

  onModelSubmitted(e) {
    if (e == true) {
      this.modalRef.hide();
      this.ngOnInit();
    }
  }
}
